module.exports = __webpack_public_path__ + "img/Mueller.5c301a1b.jpg";